<div class="contact">
  <spark-summary-card
    [isClickable]="true"
    (onClick)="onClick(contact)"
    [link]="isNavigatable ? ['/Contacts', contact.entityType, contact.id] : []">
    <summary-card-icon>
      <ng-container *ngIf="contact.entityType">
        <lds-icon
          [name]="contact.entityType | applicantIcon"
          size="md"
          appearance="inherit"></lds-icon>
      </ng-container>
    </summary-card-icon>

    <!-- card / content -->
    <summary-card-header>
      <div class="row align-items-center">
        <div class="col-12 col-md-3 col-lg-4">
          <div class="summary-card__title truncate">
            {{ contact.name }}
          </div>
        </div>
        <div class="col-12 col-sm-4 col-lg-4">
          <div class="entity-tags" *ngIf="contact.tags?.length">
            <span class="entity-tag-pill" *ngFor="let tagName of contact.tags">
              {{ tagName }}
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-2">
          {{ contact.contactType }}
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <div class="truncate">
            <lds-icon name="user" size="xs" appearance="inherit"> </lds-icon>
            <span class="ml-xs">
              {{ adviserName }}
            </span>
          </div>
        </div>
      </div>
    </summary-card-header>

    <!-- card / action -->
    <summary-card-actions>
      <lds-icon summary-card-action name="arrow-right" appearance="inherit">
      </lds-icon>
    </summary-card-actions>
  </spark-summary-card>
</div>
